import axios from "axios";

const model = "Containers";

export default {
  propertyInfoDocument(type) {
    return axios.get(`/${model}/propertyInfoDocument?type=${type}`, {
      responseType: "arraybuffer"
    });
  }
};
